import {Inject, Injectable} from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common'

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';

@Injectable()
export class ExportService {

  constructor(public datepipe: DatePipe) { }
  public exportAsCSVFile(json: any[], excelFileName: string): void {
    let date = new Date();
    let latest_date = this.datepipe.transform(date, 'dd_MM_yyyy');
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const csvOutput: string = XLSX.utils.sheet_to_csv(worksheet);
    FileSaver.saveAs(new Blob([csvOutput]), `${excelFileName}_${latest_date}${EXCEL_EXTENSION}`);
  }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/export.service.ts